import { render } from "./icon.vue?vue&type=template&id=3544cff3"
import script from "./icon.vue?vue&type=script&lang=ts"
export * from "./icon.vue?vue&type=script&lang=ts"
script.render = render

export default script